export const popUpEnum = {
    MANAGERCALL: "ManagerCall",
    TECHNICIANVISIT: "TechnicianVisit",
    FOLLOWUPREFUND: "FollowUpRefund",
    REFUND: "Refund",
    PLANCHANGE: "PlanChange",
    ABROAD_PACKAGE: "AbroadPackage",
    CUSTOMER_DEVLIVERIES: "CustomerDeliveries",
    FINANCE_ISSUE: "FinanceIssue"
}